import { useSelector } from 'react-redux';

import { IReduxState } from '../../types/redux';
import { coworkingOfferTypeFromJsonQuery, FCoworkingOfferType } from '../../utils/category';

export function useCoworkingOfferTypeSelector() {
  return useSelector<IReduxState, FCoworkingOfferType>(state =>
    coworkingOfferTypeFromJsonQuery(state.filters.jsonQuery),
  );
}
